import { makeHttpRequest } from "@/shared";

export const deletePaymentType = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/payment-type/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
